import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class AuthenticationHttpInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if (this.authService.user) {
      request = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + this.authService.user.access_token,
        },
      });
    }

    return next.handle(request);
  }
}
